import { render, staticRenderFns } from "./order-city-town.vue?vue&type=template&id=648e57f3&scoped=true"
import script from "./order-city-town.vue?vue&type=script&lang=js"
export * from "./order-city-town.vue?vue&type=script&lang=js"
import style0 from "./order-city-town.vue?vue&type=style&index=0&id=648e57f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648e57f3",
  null
  
)

export default component.exports